var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4533_9559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7584 1.92243V22.0776C19.7584 22.3222 19.6612 22.5568 19.4882 22.7298C19.3152 22.9028 19.0806 23 18.836 23H4.40913C4.16448 23 3.92986 22.9028 3.75687 22.7298C3.58388 22.5568 3.48669 22.3222 3.48669 22.0776V7.89057L8.56007 1H18.836C19.0806 1 19.3152 1.09718 19.4882 1.27017C19.6612 1.44316 19.7584 1.67779 19.7584 1.92243Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56008 1.00879V6.92619C8.56008 7.17083 8.4629 7.40546 8.28991 7.57845C8.11692 7.75144 7.88229 7.84862 7.63765 7.84862H3.50977L8.56008 1.00879Z",
    fill: "#CFD0D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5229 13.6006H0.922432C0.412987 13.6006 0 14.0136 0 14.523V19.1536C0 19.6631 0.412987 20.0761 0.922432 20.0761H13.5229C14.0323 20.0761 14.4453 19.6631 14.4453 19.1536V14.523C14.4453 14.0136 14.0323 13.6006 13.5229 13.6006Z",
    fill: "#FF3717"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68594 17.2118V18.2081H3.88342V15.4731H4.99034C5.20579 15.4614 5.42123 15.496 5.62221 15.5745C5.76524 15.6393 5.88569 15.7453 5.96812 15.8789C6.05154 16.0182 6.09465 16.1778 6.09265 16.3401C6.09806 16.4579 6.07776 16.5754 6.03315 16.6845C5.98855 16.7937 5.92072 16.8918 5.83437 16.972C5.64211 17.1392 5.39239 17.2252 5.13793 17.2118H4.68594ZM4.68594 16.6261H4.95344C5.18866 16.6261 5.30397 16.5339 5.30397 16.354C5.30397 16.1741 5.19789 16.0957 4.98112 16.0957H4.68594V16.6261ZM6.39244 18.2081V15.4731H7.4025C7.58658 15.4592 7.77134 15.4887 7.94195 15.5592C8.11256 15.6297 8.26427 15.7392 8.38489 15.8789C8.6022 16.1456 8.7182 16.4805 8.71235 16.8244C8.73182 17.1898 8.60579 17.548 8.36183 17.8206C8.24601 17.9491 8.1033 18.0504 7.94386 18.1173C7.78442 18.1843 7.61218 18.2153 7.4394 18.2081H6.39244ZM7.19495 17.5762H7.4025C7.47152 17.575 7.539 17.5556 7.59812 17.52C7.65724 17.4844 7.7059 17.4337 7.73919 17.3733C7.8358 17.2071 7.88225 17.0164 7.87294 16.8244C7.87655 16.6449 7.83534 16.4674 7.75302 16.3079C7.7207 16.2429 7.67059 16.1885 7.60854 16.1509C7.54648 16.1134 7.47502 16.0942 7.4025 16.0957H7.19495V17.5762ZM10.6817 17.1842H9.83311V18.2081H9.05365V15.4731H10.94V16.1234H9.83311V16.5846H10.6817V17.1842Z",
    fill: "#EDEEEF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4533_9559",
    x: 0.486694,
    y: 0,
    width: 22.2717,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4533_9559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4533_9559",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.1c4676eaa5ab342b45163c69a6f1185e.svg";
export { ForwardRef as ReactComponent };